<ui-task-notification
  *ngIf="taskNotificationVisible && this.taskNotificationTitle"
  [tasks]="tasks"
  [title]="taskNotificationTitle"
  (closeComponent)="closeNotifications()"
></ui-task-notification>
